module.exports = __webpack_public_path__ + "img/rename.icon.30ab528a.svg";